export default function adminPartner ({ next, store }){
    if(store.getters.getUserRole!="Admin" && store.getters.getUserRole!="Partner"){
        
        return next({
           name: 'dashboard'
        })
    }
    return next()
   }